import { useLocation } from "react-router-dom";
import { useDeskSpend } from "../context/DeskSpendContext";

function isPhase1Search(pathname: string): boolean {
  return pathname === "/search" || pathname.startsWith("/search/");
}

export function BudgetLockBanner() {
  const { pathname } = useLocation();
  const { spend } = useDeskSpend();

  if (isPhase1Search(pathname)) {
    return null;
  }

  const budgetLocked = spend.desk_locked;
  const extractionCapOnly = !budgetLocked && spend.evidence_cap_reached;

  if (!extractionCapOnly) {
    return null;
  }

  return (
    <div
      className="shrink-0 border-b border-tertiary bg-tertiary/10 px-4 py-3 text-on-surface"
      role="status"
    >
      <p className="font-data-label text-data-label uppercase tracking-widest text-tertiary">
        Phase 2 extraction cap reached
      </p>
      <p className="text-body-sm mt-1">
        This job has processed the maximum number of evidence pages through Phase 2 extraction (
        {spend.evidence_count} / {spend.evidence_cap}). New extractions are disabled until an
        administrator raises <code className="text-primary">MAX_EVIDENCE_PAGES_PER_JOB</code>.
        Regenerate, Execute, Synthesize, and Force re-process remain available.
      </p>
      <p className="text-body-sm mt-1 tabular-nums text-on-surface-variant">
        Spent ${spend.spend_usd.toFixed(2)} / ${spend.budget_usd.toFixed(2)} ·{" "}
        {(spend.evidence_eligible ?? spend.evidence_count) > 0
          ? `${spend.evidence_count}/${spend.evidence_eligible ?? spend.evidence_count} extracted`
          : `${spend.evidence_count}/${spend.evidence_cap} extracted`}
        {(spend.evidence_pending ?? 0) > 0 ? ` · ${spend.evidence_pending} pending` : ""}
        {(spend.evidence_off_target ?? 0) > 0
          ? ` · ${spend.evidence_off_target} off-target`
          : ""}
      </p>
    </div>
  );
}
